import { api } from './client'
import type { CurrentUser, LoginResponse } from '@/types/auth'

// §7 Auth contract (/auth/*). client_type='admin' makes the backend reject STUDENT (403).
export async function login(email: string, password: string): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>('/auth/login', {
    email,
    password,
    device_id: 'admin-web',
    client_type: 'admin',
  })
  return data
}

export async function logout(): Promise<void> {
  try {
    await api.post('/auth/logout')
  } catch {
    // best-effort; local tokens are cleared regardless
  }
}

export async function getMe(): Promise<CurrentUser> {
  const { data } = await api.get<CurrentUser>('/auth/me')
  return data
}

export async function updateProfile(body: { full_name?: string; email?: string }): Promise<CurrentUser> {
  const { data } = await api.put<CurrentUser>('/auth/profile', body)
  return data
}

export async function changePassword(body: {
  current_password: string
  new_password: string
}): Promise<{ success: boolean; message: string }> {
  const { data } = await api.post('/auth/change-password', body)
  return data
}
